import { useLazyQuery, useMutation } from "@apollo/client";
import {
  getCompletedSurveyResponse,
  getLearningResponse,
  getPeopleSurveyResponse,
  submitLearningResponse,
} from "GraphQL/queries/listCheckins";
import { get } from "lodash";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  surveyResponseState,
  learningResponseState,
  checkinOverviewLoaderState,
  checkinDetailsVariables,
  authPageState,
  anchorElState,
  downloadLoaderState,
} from "Recoil/Checkins/atom";
import { FETCH_POLICY } from "src/constants";
import { useCheckinDetailGrid } from "./useCheckinDetailGrid";
import { useHistory } from "react-router";
import { getSingleCheckIn } from "GraphQL/queries/targetDetail";
import { checkinOverviewDownload } from "GraphQL/queries/checkin/download";
import { useFormContext } from "react-hook-form";
import { useState } from "react";

let count = 0;

export const useCheckinDetails = (name, methods) => {
  // const { setValue } = useFormContext();
  // const methods = useFormContext();

  const setSurveyResponseData = useSetRecoilState(surveyResponseState);
  const setLearningResponseData = useSetRecoilState(learningResponseState);
  const setLoader = useSetRecoilState(checkinOverviewLoaderState);
  const setAuthPageState = useSetRecoilState(authPageState);
  const checkinVariables = useRecoilValue(checkinDetailsVariables);
  const {
    formatSurveyQuestionWise,
    formatSurveyPeopleWise,
    formatLearningResponse,
  } = useCheckinDetailGrid();
  const history = useHistory();
  // const setAnchorEl = useSetRecoilState(anchorElState);
  const [anchorEl, setAnchorEl] = useState(null);
  const setDownloadLoader = useSetRecoilState(downloadLoaderState);
  // const [downloadLoader, setDownloadLoader] = useState(downloadLoaderState);
  const handleClose = () => {
    setAnchorEl(anchorElState);
  };
  const onCompleteGetSurveyQuestionWise = (data) => {
    count = +1;
    setLoader((res) => ({ ...res, surveyQuestionWiseLoader: false }));
    const fetchedData = formatSurveyQuestionWise(
      get(data, "getCheckIn.completeSurveyCheckin.completedSurveyCheckin", []),
      count
    );
    setSurveyResponseData(fetchedData);

    if (get(data, "getCheckIn.completeSurveyCheckin.nextToken", "")) {
      const variables = {
        ...checkinVariables,
        nextToken: get(
          data,
          "getCheckIn.completeSurveyCheckin.nextToken",
          null
        ),
      };
      getSurveyQuestionWise({ variables });
    }
  };

  const [getSurveyQuestionWise] = useLazyQuery(getCompletedSurveyResponse, {
    fetchPolicy: FETCH_POLICY.networkOnly,
    onError: (err) => {
      setLoader((res) => ({ ...res, surveyQuestionWiseLoader: false }));
      onCompleteGetSurveyQuestionWise({});
      if (err.message === "You are not authorized to view check-in details.") {
        setAuthPageState(true);
      }
    },
    onCompleted: (data) => {
      onCompleteGetSurveyQuestionWise(data);
    },
  });

  const [getSurveyPeopleWise] = useLazyQuery(getPeopleSurveyResponse, {
    fetchPolicy: FETCH_POLICY.networkOnly,
    onError: (err) => {
      setLoader((res) => ({
        ...res,
        surveyPeopleWiseLoader: false,
        learningLoader: false,
      }));
      setSurveyResponseData([]);
      if (err.message === "You are not authorized to view check-in details.") {
        setAuthPageState(true);
      }
    },
    onCompleted: (data) => {
      setLoader((res) => ({
        ...res,
        surveyPeopleWiseLoader: false,
        learningLoader: false,
      }));
      const fetchedData = formatSurveyPeopleWise(
        get(data, "getCheckinDetails", [])
      );
      if (history?.location?.state?.respondedUserId) {
        let responseData = fetchedData.slice();
        let index = responseData.findIndex(
          (d) => d.id === history?.location?.state?.respondedUserId
        );
        responseData[index] = {
          ...responseData[index],
          expanded: true,
        };

        setSurveyResponseData(responseData);
      } else {
        setSurveyResponseData(fetchedData);
      }
    },
  });

  const [submitLearningReview] = useMutation(submitLearningResponse);

  const [getLearning] = useLazyQuery(getLearningResponse, {
    fetchPolicy: FETCH_POLICY.networkOnly,
    onError: (err) => {
      setLoader((res) => ({
        ...res,
        learningLoader: false,
        surveyPeopleWiseLoader: false,
      }));
      if (err.message === "You are not authorized to view check-in details.") {
        setAuthPageState(true);
      }
    },
    onCompleted: (data) => {
      setAuthPageState(false);
      setLoader((res) => ({
        ...res,
        learningLoader: false,
        surveyPeopleWiseLoader: false,
      }));
      const fetchedData = formatLearningResponse(
        get(data, "getCheckinDetails.userCheckinData", [])
      );
      setLearningResponseData(fetchedData);
    },
  });

  // const [downloadCheckinOverload] = useLazyQuery(checkinOverviewDownload, {
  const handleDownload = (data) => {
    handleClose();
    const a = document.createElement("a");
    a.href = get(data, "checkinOverviewDownload.file", "");
    a.download = get(data, "checkinOverviewDownload.fileName", "");
    a.click();
    setDownloadLoader(false);
  };
  //   fetchPolicy: FETCH_POLICY.networkOnly,
  //   onCompleted: (data) => {
  //     setAnchorEl(null);

  //     const a = document.createElement("a");
  //     a.href = get(data, "checkinOverviewDownload.file", "");
  //     a.download = get(data, "checkinOverviewDownload.fileName", "");
  //     a.click();
  //     setDownloadLoader(false);
  //   },
  // });
  const [downloadCheckinOverload] = useLazyQuery(checkinOverviewDownload, {
    fetchPolicy: FETCH_POLICY.networkOnly,
    onCompleted: (data) => {
      handleDownload(data);
    },
  });

  const [getSingleCheckinData] = useLazyQuery(getSingleCheckIn, {
    fetchPolicy: FETCH_POLICY.networkOnly,
    onError: () => setAuthPageState(true),
    onCompleted: (data) => {
      const { setValue } = { ...methods };
      const checkin = get(data, "getCheckIn");
      setValue(`${name}.checkinFrequencyDates`, checkin?.checkinFrequencyDates);
      // setValue(`checkinFrequencyDates`, checkin?.checkinFrequencyDates);
      setValue(`${name}.scheduleFrequency`, checkin?.scheduleFrequency);

      // setValue(`scheduleFrequency`, checkin?.scheduleFrequency);
    },
  });
  return {
    getSingleCheckinData,
    downloadCheckinOverload,
    getSurveyQuestionWise,
    getLearning,
    getSurveyPeopleWise,
    setLoader,
    submitLearningReview,
  };
};
